export default __webpack_public_path__ + "static/watabe-864d919c6ea418191b7c73e1f76cd12f.jpg";